import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { api_url, DEFAULT_LOGO_SRC } from "../../constant/constant";
import { useTranslation } from "react-i18next";

function CreatePassword() {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);

    const { t } = useTranslation();
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);
    const ldap_token = searchParams.get("ldap_token");
    const token = searchParams.get("token");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");

        if (password !== confirmPassword) {
            setError(t("Passwordsdonotmatch."));
            return;
        }

        if (!token) {
            setError(t("Usernotauthenticated."));
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(`${api_url}/ldap/complete-password-setup`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    password: password,
                    password_confirmation: confirmPassword,
                    ldap_token: ldap_token
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                setError(t(data.message || "Failedtoupdatepassword."));
                throw new Error(data.message);
            }

            if (data.status === "success") {
                setSuccess(t(data.message || "Passwordupdatedsuccessfully."));
                setTimeout(() => {
                    window.location.href = "/login";
                }, 2000);
            } else {
                setError(t("Somethingwentwrong."));
            }
        } catch (err) {
            console.error(err.message);
            setError(t("Anerroroccurred."));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container" style={{ height: '100vh' }}>
            <div className="row justify-content-center">
                <div className="col-md-5 mb-5">
                    <div className="loginLogo mt-5" align="center">
                        <img src={DEFAULT_LOGO_SRC} alt="Cyber Sense"style={{width:'160px'}} />
                    </div>
                    <div className="card mt-5 pb-5" style={{ borderRadius: "30px" }}>
                        <div className="card-body">
                            <h2 className="m-5 txtLoginAccount" align="center">
                                {t('CreatePassword')}
                            </h2>

                            {error && <div className="alert alert-danger">{error}</div>}
                            {success && <div className="alert alert-success">{success}</div>}

                            <form onSubmit={handleSubmit} className="px-5">
                                <div className="form-group mb-3">
                                    <label htmlFor="password">{t("NewPassword")}</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                </div>

                                <div className="form-group mb-3">
                                    <label htmlFor="confirmPassword">{t("ConfirmPassword")}</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="confirmPassword"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        required
                                    />
                                </div>

                                <button
                                    type="submit"
                                    className="btn btn-dark w-100 p-2"
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        t("UpdatePassword")
                                    )}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CreatePassword;
